import { FormProps } from "antd";

export const ticketPoolFormLayout: Pick<
  FormProps,
  "labelCol" | "wrapperCol" | "labelAlign"
> = {
  wrapperCol: {
    xs: { span: 0 },
    md: { span: 8 },
  },
  labelCol: {
    xs: { span: 0 },
    md: { span: 8 },
  },
};
